import { useEffect } from 'react';
import LoadingScreen from './LoadingScreen';

type Props = {
  to: string;
};

export default function ExternalRedirect({ to }: Props) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <LoadingScreen />;
}
